import simg1 from '../img/service/01.png'
import simg2 from '../img/service/02.png'
import simg3 from '../img/service/03.png'
import simg4 from '../img/service/04.png'

import simg7 from '../img/service/06.png'
import simg8 from '../img/service/07.png'
import simg9 from '../img/service/08.png'

import simg10 from '../img/service/09.png'
import simg11 from '../img/service/10.png'
import simg12 from '../img/service/09.png'
import simg13 from '../img/service/10.png'

import simg14 from '../img/service/s1.jpg'
import simg15 from '../img/service/s2.jpg'
import simg16 from '../img/service/s3.jpg'
import simg17 from '../img/service/s2.jpg'

import sSimg1 from '../img/service-details/1.jpg'
import sSimg2 from '../img/service-details/2.jpg'
import sSimg3 from '../img/service-details/3.jpg'
import sSimg4 from '../img/service-details/4.jpg'
import sSimg5 from '../img/service-details/5.jpg'
import sSimg6 from '../img/service-details/6.jpg'
import sSimg7 from '../img/service-details/7.jpg'
import sSimg8 from '../img/service-details/8.jpg'
import sSimg9 from '../img/service-details/9.jpg'
import sSimg10 from '../img/service-details/10.jpg'
import sSimg11 from '../img/service-details/11.jpg'
import sSimg12 from '../img/service-details/12.jpg'
import sSimg13 from '../img/service-details/13.jpg'
import sSimg14 from '../img/service-details/14.jpg'
import sSimg15 from '../img/service-details/15.jpg'
import sSimg16 from '../img/service-details/16.jpg'
import sSimg17 from '../img/service-details/17.jpg'




const Services = [
   {
      Id: '01',
      sImg: simg1,
      sSImg: sSimg1,
      title: 't-shirt printing',
      slug: 't-shirt-printing',
      description: 'Take a trivial example which of us ever…',
   },
   {
      Id: '02',
      sImg: simg2,
      sSImg: sSimg2,
      title: 'Sticker printing',
      slug: 'Sticker-printing',
      description: 'Take a trivial example which of us ever…',
   },
   {
      Id: '03',
      sImg: simg3,
      sSImg: sSimg3,
      title: 'Digital Scanning',
      slug: 'Digital-Scanning',
      description: 'Take a trivial example which of us ever…',
   },
   {
      Id: '04',
      sImg: simg4,
      sSImg: sSimg4,
      title: 'Gift item printing',
      slug: 'Gift-item-printing',
      description: 'Take a trivial example which of us ever…',
   },
   {
      Id: '05',
      sImg: simg1,
      sSImg: sSimg5,
      title: 't-shirt printing',
      slug: 't-shirt-printing-2',
      description: 'Take a trivial example which of us ever…',
   },
   {
      Id: '06',
      sImg: simg1,
      sSImg: sSimg6,
      title: 't-shirt printing',
      slug: 't-shirt-printing-3',
      description: 'Take a trivial example which of us ever…',
   },
   {
      Id: '07',
      sImg: simg7,
      sSImg: sSimg7,
      ItemS:'01',
      title: 'Personalize Gift',
      slug: 'Personalize-Gift',
      description: 'full administration printing backgroun or your online business Beautiful',
   },
  
   {
      Id: '08',
      sImg: simg8,
      sSImg: sSimg8,
      ItemS:'02',
      title: 'Custom designing',
      slug: 'Custom-designing',
      description: 'full administration printing backgroun or your online business Beautiful',
   },
  
   {
      Id: '09',
      sImg: simg9,
      sSImg: sSimg9,
      ItemS:'03',
      title: 'Packaging & level',
      slug: 'Personalize-Gift',
      description: 'full administration printing backgroun or your online business Beautiful',
   },
   {
      Id: '10',
      sImg: simg10,
      sSImg: sSimg10,
      ItemS:'03',
      title: 'Printing Service',
      slug: 'Printing-Service',
      description: 'full administration printing background or your online business Beautiful',
   },
  
   {
      Id: '11',
      sImg: simg11,
      sSImg: sSimg11,
      ItemS:'03',
      title: 'Designing Service',
      slug: 'Designing-Service',
      description: 'full administration printing background or your online business Beautiful',
   },
   {
      Id: '12',
      sImg: simg12,
      sSImg: sSimg12,
      ItemS:'03',
      title: 'Digital Scanning',
      slug: 'Digital-Scanning',
      description: 'full administration printing background or your online business Beautiful',
   },
  
   {
      Id: '13',
      sImg: simg13,
      sSImg: sSimg13,
      ItemS: '03',
      title: 'Printing Service',
      slug: 'Printing-Service',
      description: 'full administration printing background or your online business Beautiful',
   },
   {
      Id: '14',
      sImg: simg14,
      sSImg: sSimg14,
      ItemS: '04',
      title: 'Printing Service',
      slug: 'Printing-Service1',
      description: 'full administration printing background or your online business Beautiful',
   },
   {
      Id: '15',
      sImg: simg15,
      sSImg: sSimg15,
      ItemS: '05',
      title: 'Printing Service',
      slug: 'Printing-Service2',
      description: 'full administration printing background or your online business Beautiful',
   },
   {
      Id: '16',
      sImg: simg16,
      sSImg: sSimg16,
      ItemS: '06',
      title: 'Printing Service',
      slug: 'Printing-Service3',
      description: 'full administration printing background or your online business Beautiful',
   },
   {
      Id: '17',
      sImg: simg17,
      sSImg: sSimg17,
      ItemS: '07',
      title: 'Printing Service',
      slug: 'Printing-Service6',
      description: 'full administration printing background or your online business Beautiful',
   },

]

export default Services;